module.exports = __webpack_public_path__ + "img/bannerLab3.98fb2c51.png";